var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: "url(#paint0_linear_33_14)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65831 12.368C9.30231 10.7803 11.7322 9.73365 12.948 9.22796C16.4194 7.78409 17.1407 7.53327 17.6109 7.52499C17.7143 7.52317 17.9455 7.5488 18.0953 7.67032C18.2217 7.77293 18.2565 7.91155 18.2732 8.00884C18.2898 8.10612 18.3105 8.32775 18.2941 8.50092C18.1059 10.4775 17.292 15.274 16.8779 17.4878C16.7026 18.4245 16.3576 18.7386 16.0236 18.7693C15.2977 18.8361 14.7465 18.2896 14.0434 17.8287C12.9433 17.1076 12.3217 16.6586 11.2538 15.9549C10.0197 15.1416 10.8198 14.6946 11.5231 13.9641C11.7072 13.7729 14.9055 10.8638 14.9674 10.5999C14.9751 10.5669 14.9823 10.4439 14.9092 10.3789C14.8361 10.3139 14.7283 10.3362 14.6504 10.3538C14.5401 10.3789 12.7825 11.5405 9.37784 13.8388C8.87897 14.1814 8.42711 14.3483 8.02226 14.3395C7.57595 14.3299 6.71742 14.0872 6.07919 13.8797C5.29637 13.6252 4.67421 13.4907 4.72839 13.0586C4.7566 12.8335 5.06658 12.6033 5.65831 12.368Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_14",
    x1: 1250,
    y1: 0,
    x2: 1250,
    y2: 2481.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "#1E1E1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.a75179a4680e947053233657b86bc13e.svg";
export { ForwardRef as ReactComponent };